import { Component, Input, OnInit } from '@angular/core';

@Component({
  selector: 'app-form-error-messages',
  templateUrl: './form-error-messages.component.html',
  styleUrls: ['./form-error-messages.component.scss']
})
export class FormErrorMessagesComponent implements OnInit {
  @Input() form: any = '';
  @Input() question: any = '';
  @Input() formGroup: any = '';
  @Input() submitted: any = '';

  constructor() { }

  ngOnInit(): void {
  }

}
